import isIOS from '@anm/helpers/is/isIOS';

type HelperProps = {
  frameMaxHeight: number;
  file?: File;
  videoSrc?: string;
  frameSecond?: number;
  streamVideo?: HTMLVideoElement;
};

const getFrameSrc = (video: HTMLVideoElement, frameMaxHeight: number) => {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d')!;
  const previewWidth = Math.round((video.videoWidth * frameMaxHeight) / video.videoHeight);
  canvas.width = previewWidth;
  canvas.height = frameMaxHeight;
  context.drawImage(video, 0, 0, canvas.width, canvas.height);

  const result = canvas.toDataURL('image/jpeg');
  const isGrabbed = new RegExp('image/jpeg;base64').test(result);

  if (!isGrabbed) return;

  return result;
};

const getFrameFromVideo = ({ file, videoSrc, frameSecond = 0, frameMaxHeight, streamVideo }: HelperProps) =>
  new Promise<string>((resolve, reject) => {
    if (streamVideo) {
      const frameSrc = getFrameSrc(streamVideo, frameMaxHeight);

      frameSrc ? resolve(frameSrc) : reject();
    }

    if (!file && !videoSrc) {
      throw new Error('Stream video of file or link required');
    }

    const video = document.createElement('video');

    const URL = window.URL || window.webkitURL;
    const createObjectURL = URL.createObjectURL || webkitURL.createObjectURL;

    let src = videoSrc || '';

    if (file) {
      const blob = new Blob([file], { type: 'video/mp4' });
      src = createObjectURL(blob);
    }
    video.src = src;

    const preloadVideo = () => {
      const isBuffered = !!video.buffered.length;
      if (isBuffered) return;

      video.load();
    };

    isIOS() && preloadVideo();

    const handleVideoSeeked = () => {
      const previewUrl = getFrameSrc(video, frameMaxHeight);

      previewUrl ? resolve(previewUrl) : reject(previewUrl);
    };

    const onError = (e: any) => reject(e);

    const onLoadedData = () => (video.currentTime = frameSecond);

    video.addEventListener('error', onError);
    video.addEventListener('seeked', handleVideoSeeked);
    video.addEventListener('loadeddata', onLoadedData);

    return () => {
      URL.revokeObjectURL(src);
      video.removeEventListener('error', onError);
      video.removeEventListener('seeked', handleVideoSeeked);
      video.removeEventListener('loadeddata', onLoadedData);
    };
  });

export default getFrameFromVideo;
